import React from 'react'
import Signup from '../components/Signup'

function SignupPage() {
  return (
    <div><Signup/></div>
  )
}

export default SignupPage